<template>
  <v-dialog v-model="dialogProps" width="500">
    <v-card width="100%">
      <p
        class="subtitle-1 text-center white--text pa-1"
        style="background: #E8175D"
      >Valor de Hora de uso según cantidad de Conexiones</p>
      <v-data-table
        :headers="headers"
        hide-default-header
        hide-default-footer
        :items="descuentos"
        :items-per-page="5"
        class="elevation-1"
      ></v-data-table>
      <br />
      <p
        class="subtitle-1 text-center white--text pa-1"
        style="background: #E8175D"
      >Descuento segun luminocidad de la luna</p>
      <v-data-table
        :headers="headers"
        hide-default-header
        hide-default-footer
        :items="luminocidad"
        :items-per-page="5"
        class="elevation-1"
      ></v-data-table>
      <div class="text-right">
          <v-btn small class="caption ma-3" @click="CerrarModal()">Cerrar</v-btn>
      </div>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  data() {
    return {
      dialog: false,
      headers: [
        { text: "institucion", value: "insti" },
        { text: "descripcion", value: "descrip" }
      ],
      luminocidad: [
        {
          insti: "Luminocidad <= 20%",
          descrip: "0%"
        },
        {
          insti: "Luminocidad > 20% y <= 45%",
          descrip: "25%"
        },
        {
          insti: "Luminocidad > 45% y <= 80%",
          descrip: "50%"
        }
      ],
      descuentos: [
        {
          insti: "Hasta 5 conexiones",
          descrip: "$100.00"
        },
        {
          insti: "Hasta 15 conexiones",
          descrip: "$120.00"
        },
        {
          insti: "Hasta 60 conexiones",
          descrip: "$180.00"
        }
      ]
    };
  },
  props: ["dialogProps"],
  methods: {
    CerrarModal() {
      this.$emit("respModal", this.dialog);
    }
  }
};
</script>